import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Scissors, MapPin, Phone, Clock, Instagram, Facebook, MessageCircle } from 'lucide-react';
import axios from 'axios';
import './Footer.css';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Footer() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`)
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo">
              <Scissors size={20} strokeWidth={1.5} />
              <span>{settings.salon_name || 'Patricia Pourroy'} <em>Studio</em></span>
            </div>
            <p className="footer-tagline">
              Beleza, cuidado e sofisticação em cada atendimento.
            </p>
            <div className="footer-social">
              {settings.instagram && (
                <a href={`https://instagram.com/${settings.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" aria-label="Instagram">
                  <Instagram size={18} />
                </a>
              )}
              {settings.facebook && (
                <a href={settings.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
                  <Facebook size={18} />
                </a>
              )}
              {settings.whatsapp && (
                <a href={`https://wa.me/${settings.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" aria-label="WhatsApp">
                  <MessageCircle size={18} />
                </a>
              )}
            </div>
          </div>

          <div className="footer-col">
            <h4>Navegação</h4>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><a href="#services" onClick={e => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({behavior:'smooth'}); }}>Serviços</a></li>
              <li><a href="#stylists" onClick={e => { e.preventDefault(); document.getElementById('stylists')?.scrollIntoView({behavior:'smooth'}); }}>Profissionais</a></li>
              <li><Link to="/reservar">Reservar Horário</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contato</h4>
            <div className="footer-contact-item">
              <MapPin size={15} />
              <span>{settings.address || 'Rua da Beleza, 123 — São Paulo, SP'}</span>
            </div>
            <div className="footer-contact-item">
              <Phone size={15} />
              <span>{settings.phone || '(11) 99999-9999'}</span>
            </div>
            <div className="footer-contact-item">
              <Clock size={15} />
              <span>{settings.opening_hours || 'Seg–Sáb: 9h às 19h'}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {settings.salon_name || 'Patricia Pourroy Studio'}. Todos os direitos reservados.</p>
        <p>Desenvolvido com ♥ para você</p>
      </div>
    </footer>
  );
}
